/**
 * Which of Activity's four layouts this window gets — `docs/activity.md` §10.
 *
 *   desktop    the side panel, 32 px controls (Boards 2–6, 18)
 *   landscape  an iPad on its side: no side panel, 40 px controls, a tapped
 *              stop opens beside the day (Board 12 A)
 *   portrait   an iPad held upright, or any window under 1,180: the same,
 *              Work week steps aside and a stop opens as a bottom sheet
 *              (Board 12 B)
 *   phone      Board 13
 *
 * Landscape is a finger at 1,180 or wider, or a window under 1,280 with a
 * mouse: the 248 px side panel and a seven-day grid do not both fit there.
 */
import { useCoarse, useNarrow, usePhone } from '../lib/use-narrow.js'

export type ActivityLayout = 'desktop' | 'landscape' | 'portrait' | 'phone'

export function useActivityLayout(): ActivityLayout {
  const phone = usePhone()
  const portrait = useNarrow(1179)
  const tight = useNarrow(1279)
  const coarse = useCoarse()
  if (phone) return 'phone'
  if (portrait) return 'portrait'
  if (coarse || tight) return 'landscape'
  return 'desktop'
}

/** The iPad's controls are 40 px (§10.1); the desktop's 32. */
export const isTablet = (layout: ActivityLayout): boolean => layout === 'landscape' || layout === 'portrait'
